import React from "react"
import { ArrowDownIcon } from "../../Icons"
import "./Dropdown.css"

class Dropdown extends React.Component {
  state = {
    ...this.props,
    items: this.props.items || [],
    showItems: false,
    selectedItem: this.props.items && this.props.items[0]
  }

  dropDown = () => {
    this.setState(prevState => ({
      showItems: !prevState.showItems
    }))
  }

  selectItem = item => {
    this.setState({
      selectedItem: item,
      showItems: false
    })
    this.props.form.setFieldValue(this.props.field.name, item.id)
  }
  render() {
    return (
      <div>
        <div className="select-box--box">
          <div className="select-box--containter">
            <div className="select-box--selected-item">
              {" "}
              {this.state.selectedItem.value}{" "}
            </div>
            <div className="select-box--arrow" onClick={this.dropDown}>
              <span className="select-box--arrowdown">
                {" "}
                {this.state.showItems ? (
                  <ArrowDownIcon />
                ) : (
                  <ArrowDownIcon />
                )}{" "}
              </span>
            </div>
            <div
              style={{ display: this.state.showItems ? "block" : "none" }}
              className="select-box--items"
            >
              {this.state.items.map(item => (
                <div
                  key={item.id}
                  onClick={() => this.selectItem(item)}
                  className={this.state.selectedItem === item ? "selected" : ""}
                >
                  {item.value}
                </div>
              ))}
            </div>
          </div>
          <input
            type="hidden"
            value={this.state.selectedItem.id}
            name={this.state.name}
          />
        </div>
      </div>
    )
  }
}

export default Dropdown
